export const DETERMINISTIC_COLOR_OPTIONS = [
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
] as const;

export type DeterministicColor = (typeof DETERMINISTIC_COLOR_OPTIONS)[number];

export const getDeterministicColorFromId = (
  id: string,
  options?: {
    omit?: DeterministicColor[];
  },
): DeterministicColor => {
  const colors = DETERMINISTIC_COLOR_OPTIONS.filter(
    (color) => !options?.omit?.includes(color),
  );
  let hash = 0;

  for (let index = 0; index < id.length; index += 1) {
    hash = (hash * 31 + id.charCodeAt(index)) >>> 0;
  }

  return colors[hash % colors.length] ?? DETERMINISTIC_COLOR_OPTIONS[0];
};
